import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

interface QuestionSectionProps {
  hasError: boolean;
}

export const DialogWrapper = styled('div')<{ open: boolean }>(({ open }) => ({
  display: open ? 'flex' : 'none',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9999,
  padding: '32px',
}));

export const ModalContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: customPalette.accent.white,
  borderRadius: '8px',
  maxWidth: '1900px',
  width: '100%',
  height: '85vh',
  maxHeight: '90vh',
  position: 'relative',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
  overflow: 'hidden',
});

export const StyledDialogTitle = styled('h2')({
  fontWeight: 'bold',
  fontSize: '28px',
  color: customPalette.grey.main,
  margin: 0,
  whiteSpace: 'pre-wrap',
});

export const ModalDescription = styled(Typography)({
  color: customPalette.grey[400],
  marginBottom: '16px',
  fontSize: '16px',
  whiteSpace: 'pre-wrap',
});

export const HintWrapper = styled('div')({
  marginBottom: '24px',
});

export const InvekosWrapper = styled('div')({
  display: 'flex',
  marginBottom: '24px',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '16px',
  alignItems: 'flex-start',
});

export const InvekosInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const LastSavedInfo = styled('span')({
  display: 'block',
  color: customPalette.grey[400],
  fontSize: '16px',
  margin: '16px 0 0 0',
});

export const QuestionsContainer = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  background: '#f5f7fa',
  overflowY: 'auto',
  height: '100%',
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-track': {
    background: customPalette.grey[50],
    borderRadius: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: customPalette.grey[300],
    borderRadius: '6px',
    border: `3px solid ${customPalette.grey[50]}`,
    '&:hover': {
      backgroundColor: customPalette.grey[400],
    },
  },
});

export const ContentWrapper = styled('div')({
  flex: 1,
  padding: '24px 32px',
  display: 'flex',
  flexDirection: 'column',
  whiteSpace: 'pre-wrap',
});

export const QuestionSection = styled('div')<QuestionSectionProps>(
  ({ hasError }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    padding: '24px 0',
    borderBottom: `1px solid ${customPalette.grey[100]}`,
    borderColor: hasError
      ? customPalette.negative.main
      : customPalette.grey[100],
    '&:last-child': {
      borderBottom: 'none',
    },
  })
);

export const QuestionText = styled('p')<{ hasError?: boolean }>(
  ({ theme, hasError }) => ({
    fontSize: '18px',
    fontWeight: 600,
    color: hasError ? theme.palette.error.main : customPalette.grey.main,
    margin: '0 0 12px 0',
    lineHeight: '1.5',
    transition: 'color 0.2s ease',
    whiteSpace: 'pre-wrap',
  })
);

export const QuestionDescription = styled(Typography)({
  marginBottom: '16px',
  color: customPalette.grey[800],
  whiteSpace: 'pre-wrap',
});

export const RadioGroupWrapper = styled('div')({
  marginLeft: '8px',
});

export const ConsentsSection = styled('div')({
  marginTop: '50px',
});

export const ConsentError = styled('p')({
  color: customPalette.negative.main,
  margin: '4px 0 0 24px',
  fontSize: '14px',
});

export const ButtonsContainer = styled('div')({
  backgroundColor: customPalette.accent.white,
  padding: '24px 32px',
  borderTop: `1px solid ${customPalette.grey[100]}`,
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  marginTop: 'auto',
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
  width: '100%',
});
export const ButtonsWrapper = styled('div')({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& button': {
    height: 'max-content',
  },
});

export const HeaderContentWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const CloseButtonWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
});

export const ModalHeader = styled('div')({
  backgroundColor: customPalette.accent.white,
  padding: '24px 32px',
  borderBottom: `1px solid ${customPalette.grey[100]}`,
  zIndex: 2,
});

export const ConfirmModalWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
});

export const WarningMessage = styled('div')({
  color: customPalette.negative.main,
  fontSize: '18px',
  fontWeight: 'bold',
  textAlign: 'left',
  width: '70%',
});

export const InvekosHeader = styled('p')`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) =>
    props.isMissing ? customPalette.negative.main : customPalette.grey.main};
  margin: 0 0 12px 0;
  line-height: 1.5;
  flex-direction: column;
`;
